import { render, staticRenderFns } from "./PdlDetailLocations.vue?vue&type=template&id=4de1631e"
import script from "./PdlDetailLocations.vue?vue&type=script&lang=js"
export * from "./PdlDetailLocations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports